/**
 * Mensaje de error de una descarga pedida con responseType "blob".
 * El servidor responde JSON ({ error } o { message }), pero axios lo entrega como Blob,
 * así que hay que leerlo para mostrar el motivo real (rango no permitido, exportación en curso, etc.).
 */
export async function mensajeErrorDescarga(error, porDefecto) {
  const data = error?.response?.data;

  try {
    const json = data instanceof Blob ? JSON.parse(await data.text()) : data;
    return json?.error || json?.message || porDefecto;
  } catch {
    return porDefecto;
  }
}
